import { render, staticRenderFns } from "./input-folders.vue?vue&type=template&id=045d1814&"
import script from "./input-folders.vue?vue&type=script&lang=js&"
export * from "./input-folders.vue?vue&type=script&lang=js&"
import style0 from "./input-folders.vue?vue&type=style&index=0&id=045d1814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports